import ApiService from "@/services/api.service";

export async function changePayoutState(payoutId, state) {
    let response = await ApiService.get(`payout/${payoutId}/status/${state}`);
    console.log(response);
    return response.data;
}